import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import DeletedUsersViewModelType from '@/ViewModels/Controls/DeletedUsersViewModel';
import GridType from '@/Controls/CoreFrameGridControl';

export default class DeletedUsers extends Control {

    private Grid = ComponentManager.getControl<typeof GridType>('CoreFrameGrid');
    private jQueryControl: JQuery;
    private grid: GridType;

    public constructor(private viewModel: DeletedUsersViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'deletedusers',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible
        });

        if (this.viewModel.grid != null) {
            this.grid = new this.Grid(this.viewModel.grid);
            let tuple = this.grid.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('DeletedUsers', DeletedUsers, 'RADPresentation.HTMLClient.DefaultViewExtensions');